import script from "./AvatarTomView.vue?vue&type=script&setup=true&lang=js"
export * from "./AvatarTomView.vue?vue&type=script&setup=true&lang=js"

import "./AvatarTomView.vue?vue&type=style&index=0&id=067a83ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-067a83ba"]])

export default __exports__